import { render, staticRenderFns } from "./FeaturedGrid.vue?vue&type=template&id=cfbefdb6&scoped=true"
import script from "./FeaturedGrid.vue?vue&type=script&lang=js"
export * from "./FeaturedGrid.vue?vue&type=script&lang=js"
import style0 from "./FeaturedGrid.vue?vue&type=style&index=0&id=cfbefdb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbefdb6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogChip: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/chip.vue').default})
